const quotes = [
    {
        id: 1,
        content: '“The team at Peekage works closely with the brand team to effectively drive trials at your key retail locations through their digital sampling platform. They seemed invested in making sure our program achieved our desired outcome.”',
        component: 'Quote',
        image: 'testimonials/Image-4.png',
        details: {
            name: 'Theresa Sarna',
            position: 'Senior Marketing Manager',
            corp: 'Bubbies Mochi Ice Cream',
        },
    },
    {
        id: 2,
        content: "“We've been able to attract first time buyers on a consistent basis through our campaigns with Peekage. Not only are we seeing actual results, but the team has been working closely with us to continue optimizing our campaigns. Truly amazing service.”",
        component: 'Quote',
        image: 'testimonials/Image-6.png',
        details: {
            name: 'Erin Mastopietro',
            position: 'CEO',
            corp: 'Dope Dog',
        },
    },
    {
        id: 3,
        content: '“Peekage helped us to generate exceptional product reviews and testimonials for 30+ new product launches. Their product sampling platform has exceeded our expectations with the easy delivery and format. We were also able to market to new customers with Peekage’s sampling capabilities.”',
        component: 'Quote',
        image: 'testimonials/Image-3.png',
        details: {
            name: 'Lynn Tran',
            position: 'Innovation E-commerce Lead',
            corp: 'Swanson Vitamins',
        },
    },
    {
        id: 4,
        content: '“Before partnering with Peekage, finding a product sampling company that could deliver products to targeted consumers with a good distribution speed and collecting feedback in a measurable manner was a challenge. With Peekage’s product sampling services, and their insights reports, we were able to validate and measure the effectiveness of our sampling programs.”',
        component: 'Quote',
        image: 'testimonials/Image-5.png',
        details: {
            name: 'Dai Kageyama',
            position: 'Senior Director of Marketing',
            corp: 'Hartz',
        },
    },
];

export default quotes;
